$(document).ready(function(){
    
    // announcement-bar js
    $('.announcement-bar').slick({
        autoplay : true,
        autoplaySpeed : 3000, 
        speed: 800,
        slidesToShow : 1,
        arrows : false,
        dots : false,
        pauseOnHover: true
    });
  


function numOrdDesc(a, b) {
  return (b - a);
}
    
    // mobile js
    if ($(window).width() <= 720 ){
        $("#shopify-section-static-announcement").appendTo("#shopify-section-static-basic-header");
    }
    // desk js
    else{
        // on hover zooom image
        $(".product-gallery--image-background").on("mouseover", function() {
            $(this).children("img").css({ 
                transform: "scale(2.2)",
                transition: ".25s ease"
            });
        }).on("mouseout", function() {
            $(this).children("img").css({ transform: "scale(1)" });
        }).on("mousemove", function(e) {
            $(this).children("img").css({
                transition: ".1s ease",
                "transform-origin":
                ((e.pageX - $(this).offset().left) / $(this).width()) * 100 +"%"+
                ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +"%"
            });
        });
    }
    
    // pdp gallery slider
    $('#pdp-slider').slick({  
        slidesToShow : 2,
        slideToScroll: 2,
        arrows : true,
        dots:true,
        responsive: [
            {
                breakpoint: 719,
                settings:{
                    slidesToShow : 1,
                    slideToScroll: 1,
                }
            }
        ]
    });
    
    $(document).on('click','.productgrid--sidebar-title--small',function(){
        $(this).toggleClass('active');
        $(this).siblings().slideToggle(300);
    });
  
  function equalHeight($trigger) {
  	  var highestBox = 0;
      $($trigger).each(function(){        
        if($(this).height() > highestBox) {
          highestBox = $(this).height(); 
        }   
      });
      $($trigger).height(highestBox);
  }

    equalHeight('.productgrid--items .productitem--title');
    equalHeight('.productgrid--item .productitem--title');
    $('.faq_que').click(function(){
     $(this).parent().toggleClass('active');
     $(this).parent().siblings().removeClass('active');

     $(this).parent().siblings().children('.faq_ans').slideUp('300');
     $(this).siblings('.faq_ans').slideToggle('250');
  });
  
  $('.tablinks').click(function(e){
    e.stopPropagation();
    e.preventDefault();
    var link = $(this).attr('href');
    // console.log(link);
    $(location).attr('href', link); 
  });
  
  $("a[href^='#CustJoinUsFooter']").click(function(e) {
              e.preventDefault();

              var position = $($(this).attr("href")).offset().top - 200;

              $("body, html").animate({
                scrollTop: position
              } ,2000 );
  });
  
// start product page afterpay klarna js
jQuery(".afterpay-text1").text("4 fortnightly payments of ");
jQuery(".afterpay-text2").text(" with ");
jQuery(".afterpay-link").html('<img class="afterpay-logo-moreLink" src="https://static.afterpay.com/integration/product-page/logo-afterpay-colour.png" srcset="https://static.afterpay.com/integration/product-page/logo-afterpay-colour.png 1x, https://static.afterpay.com/integration/product-page/logo-afterpay-colour@2x.png 2x, https://static.afterpay.com/integration/product-page/logo-afterpay-colour@3x.png 3x" width="100" height="21" alt="Afterpay" style="vertical-align: middle; width: 100px; border: 0px;">');
jQuery(".afterpay-link").after('<img class="zippay-logo-moreLink" src="https://cdn.shopify.com/s/files/1/0564/7882/6664/files/Primary_Logo_Colour.png?v=1620723432" width="100" height="30" alt="Klarna" style="vertical-align: middle; width: 100px; border: 0px;">');
jQuery(".afterpay-logo").css("display","none");  
// end product page afterpay klarna js
  
// start product page sizechart js  
  $('#sizeChartTrigger').click(function(){
    $('#chartPopupWrapper').addClass('open');
    $('body').css('overflow-y','hidden');
  });

  $('#closeSizeChart').click(function(){
    $('#chartPopupWrapper').removeClass('open');
    $('body').css('overflow-y','auto');
  });
// end product page sizechart js
  var ac = $('.custom-product-grid-tag-groups-wrapper li.filter-item').hasClass("filter-item--active");
  //alert(ac);
  if(ac == true)
  {//alert("g");
    //$('.custom-product-grid-tag-groups-wrapper .productgrid--sidebar-item').show();
  }
  
});


// shop the look btn replace with add to cart
// if(__st.p === "product"){
//   var Ppage = true;
//   setInterval(function(){
//     if(Ppage){
//       let addToCartBtn =  document.querySelectorAll('button[data-product-atc]')[0],
//       stlBtn =  document.querySelectorAll('#shopthelook')[0],
//       pForm = document.querySelectorAll('.product-form--atc')[0];
//       if(stlBtn.style.display != "none"){
//         pForm.append(stlBtn);
//         addToCartBtn.style.display = "none";
//         stlBtn.classList.add('dy-add-to-cart');
//         stlBtn.innerText = "Add To Cart";
//         Ppage = false;
//       }
//       var closeBtn = document.querySelectorAll('#shopTheLook .close')[0],
//           mainBody =  document.querySelectorAll('body')[0];
//       stlBtn.addEventListener('click',() => {
//         mainBody.classList.add('popup-open');
//       })
//       closeBtn.addEventListener('click',() => {
//         mainBody.classList.remove('popup-open');
//       });
//     }
//   }, 500);
// }
//   $('body').on('stl.updateCartDetails', function(evt, cart) { 
//    jQuery.getJSON('/cart.js', function(cart) {
//   //alert('There are now ' + cart.item_count + ' items in the cart.');
//      jQuery('.site-header-cart--count').attr('data-header-cart-count', cart.item_count);
//      jQuery('.site-header-cart--count').addClass('visible');
//    } );  
//   });